"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _classnames = _interopRequireDefault(require("classnames"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _dropdown = _interopRequireWildcard(require("@insided/deprecated-preact-components/design-system-components/dropdown"));

var _MoreHoriz = _interopRequireDefault(require("@insided/shared/icons/MoreHoriz"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var MenuActionsDropdown = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(MenuActionsDropdown, _Component);

  var _super = _createSuper(MenuActionsDropdown);

  function MenuActionsDropdown() {
    (0, _classCallCheck2.default)(this, MenuActionsDropdown);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(MenuActionsDropdown, [{
    key: "render",
    value: function render() {
      var menuOptions = this.props.menuOptions;
      return (0, _preact.h)("div", {
        className: "post__action-item post__action-item--more"
      }, (0, _preact.h)(_dropdown.default, {
        size: "S",
        align: "right",
        popupName: "topic-menu-actions",
        closeOnDropdownClick: true,
        triggerElement: function triggerElement(_ref) {
          var onClick = _ref.onClick;
          return (0, _preact.h)(_phrase.default, {
            p: "accessibility_label.show_additional_post_actions",
            renderAsText: true
          }, function (accessibilityLabel) {
            return (0, _preact.h)(_Button.default, {
              className: (0, _classnames.default)('post__action-link', 'tooltip-trigger', 'js-tooltip-trigger'),
              onClick: onClick,
              onKeyDown: function onKeyDown(e) {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onClick(e);
                }
              },
              "aria-label": accessibilityLabel
            }, (0, _preact.h)(_MoreHoriz.default, {
              height: 24,
              width: 24,
              className: (0, _classnames.default)('icon--auto-width', 'icon--ellipsis', 'qa-topic-post-ellipsis')
            }));
          });
        }
      }, menuOptions.map(function (item) {
        return (0, _preact.h)(_dropdown.DropdownItem, {
          key: item.title,
          type: item.type,
          onClick: /*#__PURE__*/function () {
            var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(e) {
              var _item$onClick;

              return _regenerator.default.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return item === null || item === void 0 ? void 0 : (_item$onClick = item.onClick) === null || _item$onClick === void 0 ? void 0 : _item$onClick.call(item, e);

                    case 2:
                      return _context.abrupt("return", _context.sent);

                    case 3:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }));

            return function (_x) {
              return _ref2.apply(this, arguments);
            };
          }()
        }, (0, _preact.h)(_phrase.default, {
          p: item.title
        }));
      })));
    }
  }]);
  return MenuActionsDropdown;
}(_preact.Component);

var _default = MenuActionsDropdown;
exports.default = _default;